<template>
    <div>
        <input-field
            v-if="isMajor"
            :class="marginClass"
            class="mb-4"
            :field="surgeryFields.reason"
            field-name="reason"
            :inline="false"
            bootstrap-native
        />

        <h2 class="title" :class="marginClass">{{ $t('surgery.basalTitle') }}</h2>
        <hr class="divider">

        <date-field
            :class="marginClass"
            :field="surgeryFields.basal_date"
            field-name="date"
            v-model="basal_date"
            :datetime="true"
            :errors="fieldErrors"
        />

        <div class="d-inline-flex flex-column mr-3">
            <select-as-radio-field
                :class="marginClass"
                :field="bloodTestFields.fviii_unit"
                :errors="fieldErrors"
                field-name="fviii_unit"
                v-model="fviii_unit"
            />
            <input-field
                v-model="fviii_c"
                :class="marginClass"
                :field="bloodTestFields.fviii_c"
                :errors="fieldErrors"
                field-name="fviii_c"
                type="number"
                form-width="3"
                :unit="fviii_unit"
            />
            <input-field
                v-model="fviii_cr"
                :class="marginClass"
                :field="bloodTestFields.fviii_cr"
                :errors="fieldErrors"
                :unit="fviii_unit"
                field-name="fviii_cr"
                type="number"
                form-width="3"
            />
            <input-field
                v-model="hemoglobin"
                :class="marginClass"
                :field="bloodTestFields.hemoglobin"
                :errors="fieldErrors"
                field-name="hemoglobin"
                type="number"
                form-width="3"
                show-help-as-unit
            />
            <input-field
                v-model="platelets"
                :class="marginClass"
                :field="bloodTestFields.platelets"
                :errors="fieldErrors"
                field-name="platelets"
                type="number"
                form-width="3"
                show-help-as-unit
            />
        </div>

        <div class="d-inline-flex flex-column">
            <select-as-radio-field
                :class="marginClass"
                :field="surgeryFields.basal_inhibitor_actual"
                field-name="basal_inhibitor_actual"
                v-model="basal_inhibitor_actual"
                :errors="fieldErrors"
                :inline="false"
            />
            <checkbox-field
                :class="marginClass"
                :field="surgeryFields.is_basal_sample_frozen"
                field-name="is_basal_sample_frozen"
                v-model="is_basal_sample_frozen"
                :errors="fieldErrors"
            />
        </div>

    </div>
</template>

<script>
    import DateField from "@/components/fields/DateField";
    import InputField from "@/components/fields/InputField";
    import {mapState} from "vuex";
    import CheckboxField from "@/components/fields/CheckboxField";
    import {MAJOR_SURGERY} from "@/components/surgery/SurgeryUtils";
    import {mapStateProperty} from "@/utils/VuexHelpers";
    import SurgeryAddElementMixin from "@/components/mixins/NavigableComponentMixin";
    import {required} from "vuelidate/lib/validators";
    import SelectAsRadioField from "@/components/fields/SelectAsRadioField";
    import ScrollToErrorMixin from "@/components/mixins/ScrollToErrorMixin";

    export const EXCLUSION_BASAL_STUDY = '>5 UB';

    export default {
        name: "BasalStudy",
        components: {
            SelectAsRadioField,
            CheckboxField,
            DateField,
            InputField,
        },
        mixins: [SurgeryAddElementMixin, ScrollToErrorMixin],
        props: {
            surgeryType: {
                type: String,
            },
        },
        computed: {
            ...mapState([
                'surgeryFields',
                'bloodTestFields',
            ]),
            ...mapStateProperty([
                'surgery.basal_date',
                {path: 'surgery.basal_blood_test.fviii_c', name: 'fviii_c'},
                {path: 'surgery.basal_blood_test.fviii_cr', name: 'fviii_cr'},
                {path: 'surgery.basal_blood_test.fviii_unit', name: 'fviii_unit'},
                {path: 'surgery.basal_blood_test.hemoglobin', name: 'hemoglobin'},
                {path: 'surgery.basal_blood_test.platelets', name: 'platelets'},
                'surgery.basal_inhibitor_actual',
                'surgery.is_basal_sample_frozen',
            ]),
            isMajor() {
                return this.surgeryType === MAJOR_SURGERY;
            },
            marginClass() {
                return 'mx-4 mb-3';
            },
            fieldErrors() {
                let errors = {};
                if (this.$v.basal_date.$error) {
                    errors['date']  = [this.$t('error.required')];
                }
                if (this.$v.fviii_c.$error) {
                    errors['fviii_c']  = [this.$t('error.required')];
                }
                if (this.$v.fviii_cr.$error) {
                    errors['fviii_cr']  = [this.$t('error.required')];
                }
                if (this.$v.basal_inhibitor_actual.$error) {
                    errors['basal_inhibitor_actual']  = [this.$t('surgery.exclusionCriteriaError')];
                }
                return errors;
            },
        },
        methods: {
            validate() {
                this.$v.$touch();
                const isValid = !this.$v.$invalid;
                if (!isValid) {
                    this.$nextTick(this.scrollToError);
                }
                return isValid;
            },
            back() {},
        },
        validations: {
            basal_date: {
                required,
            },
            fviii_c: {
                required,
            },
            fviii_cr: {
                required,
            },
            basal_inhibitor_actual: {
                mustBeValid: value => value !== EXCLUSION_BASAL_STUDY
            },
        }
    };
</script>

<style scoped>
</style>